var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSportsGg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "3 1 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8787_4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 8L15.6875 6.34375L18.8125 6.8125C19.5 8 19.9062 9.3125 19.9688 10.6562L17.7188 12.625L15.8125 11.8438L14.5625 8ZM12.3438 14.8438L15.5938 12.5L17.4375 13.2812L17.7188 16.5938C16.9688 17.3438 16.1562 17.9375 15.2188 18.3438L12.3438 16.9375V14.8438ZM8.84375 5.9375L10.3125 3.1875C11.4062 2.96875 12.5625 2.96875 13.6562 3.1875L15.125 5.9375L13.9688 7.59375H10L8.84375 5.9375ZM18.125 13.1875L19.9688 11.5938C19.8438 13.1562 19.3125 14.625 18.3438 15.8438L18.125 13.1875ZM5.71875 6.03125C6.6875 4.84375 7.9375 3.9375 9.375 3.4375L8.21875 5.65625L5.71875 6.03125ZM4 10.6562C4.0625 9.3125 4.46875 7.96875 5.15625 6.8125L8.28125 6.34375L9.40625 8L8.15625 11.8125L6.25 12.625L4 10.6562ZM6.25 16.5938L6.53125 13.2812L8.375 12.5L11.625 14.8438V16.9375L8.75 18.3438C7.8125 17.9062 6.96875 17.3438 6.25 16.5938ZM4 11.5938L5.84375 13.1875L5.625 15.8438C4.6875 14.625 4.125 13.1562 4 11.5938ZM9.65625 18.6562L11.9688 17.5312V17.5625L12 17.5312L14.3125 18.6562C13.5625 18.9062 12.7812 19 12 19C11.1875 19 10.4062 18.9062 9.65625 18.6562ZM8.84375 11.9688L10.0625 8.28125H13.9062L15.125 11.9688L12 14.25L8.84375 11.9688ZM18.25 6.03125C17.2812 4.84375 16.0312 3.9375 14.5938 3.4375L15.75 5.65625L18.25 6.03125Z",
    fill: "#FFCA24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8787_4987",
    x: 0,
    y: 0.96875,
    width: 23.9688,
    height: 24.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8787_4987"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8787_4987",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsGg);
export default ForwardRef;